module.exports = __webpack_public_path__ + "img/logo_centrat_color.eabcd1c6.png";